import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import versionFile from 'version.json';

@Injectable()
export class HttpVersionInterceptorService implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = req.headers.set('PTM-App-Version', versionFile['version']);

    const newRequest = req.clone({
      headers,
    });

    return next.handle(newRequest);
  }
}
